import React, { FunctionComponent } from 'react'
import { NavigationLink, StandardLink, Typography } from '@which/seatbelt'

import classnames from 'classnames'

import { SubVerticalCrTopicPageQuery } from '../../../../generated/frontend'
import styles from './CRCategories.module.scss'

export const CRCategories: FunctionComponent<Props> = ({ categories }) => {
  // TODO: check if we need this check as part of https://whichonline.atlassian.net/browse/CDD-2156
  if (!Array.isArray(categories) || categories.length === 0) {
    return null
  }

  return (
    <ol data-testid="cr-categories" className={classnames(styles.listBase, styles.list)}>
      {categories.map(({ articleLinks, description, link, title, id }) => {
        return (
          <li className={styles.block} key={id}>
            <Typography
              className={styles.title}
              data-testid="cr-topic-heading"
              id={`super-category-${id}`}
              tag="h2"
              textStyle="title-600"
            >
              {title}
            </Typography>
            <p>{description}</p>
            <ul className={classnames(styles.listBase, styles.linkList)}>
              {articleLinks.map(({ text, href }, index) => {
                return (
                  <li key={index}>
                    <NavigationLink
                      linkStyle="primary"
                      href={href}
                      icon="chevronRight"
                      className="sb-padding-bottom-3"
                    >
                      {text}
                    </NavigationLink>
                  </li>
                )
              })}
            </ul>

            <StandardLink noAnimation={false} href={link?.href} className={styles.viewAll}>
              {link?.text}
            </StandardLink>
          </li>
        )
      })}
    </ol>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  categories: SubVerticalCrTopicPageQuery['subVerticalPage']['crCategories']['sections']
}
